import React from 'react';
// Replace these with actual images from your assets if you want side-by-side photos here
import image1 from '../../../assets/img/about/about-1.jpg';
import image2 from '../../../assets/img/page/choose-us.jpg';

const PortfolioDetailsMain = ({singleData}) => {
    return (
        <div className="portfolio__details section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 columns_sticky lg-mb-25">
                        <div className="portfolio__details-overview">
                            <h4>Project Overview</h4>
                            <div className="portfolio__details-overview-item">
                                <span>Date :</span>
                                <h6>Recent Execution</h6>
                            </div>
                            <div className="portfolio__details-overview-item">
                                <span>Client :</span>
                                <h6>Government / Public Utility</h6>
                            </div>
                            <div className="portfolio__details-overview-item">
                                <span>Category :</span>
                                <h6>Civil Infrastructure</h6>
                            </div>
                            <div className="portfolio__details-overview-item">
                                <span>Execution By :</span>
                                <h6>Arclight Developers</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="portfolio__details-area">
                            <img src={singleData?.image} alt="Civil Project" style={{ width: '100%', borderRadius: '10px' }} />
                            <h3 className="mt-25 mb-20">{singleData?.title || "Infrastructure Development Project"}</h3>
                            <p className="mb-25">
                                Arclight Developers successfully executed this project with a strict focus on durability, safety, and public utility. Whether handling heavy-duty RCC road construction, laying extensive drainage pipelines, or executing civic beautification, our team ensures that every phase meets government-grade engineering standards. We collaborate closely with local authorities to minimize public disruption while maximizing the long-term structural integrity of the development.
                            </p>
                            <div className="row mb-25">
                                <div className="col-md-6 md-mb-25">
                                    <ul className="portfolio__details-area-list">
                                        <li><i className="fas fa-check"></i>Site Survey and Engineering Ideation</li>
                                        <li><i className="fas fa-check"></i>High-Grade Material Selection</li>
                                        <li><i className="fas fa-check"></i>Structural Design Development</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <ul className="portfolio__details-area-list">
                                        <li><i className="fas fa-check"></i>Government Code Compliance</li>
                                        <li><i className="fas fa-check"></i>Efficient Labor & Machinery Management</li>
                                        <li><i className="fas fa-check"></i>Timely Project Handover</li>
                                    </ul>								
                                </div>
                            </div>
                            <h4 className="mb-20">Post-Construction Quality Assurance</h4>
                            <p>Our dedication to quality does not end when the heavy machinery leaves. We conduct thorough post-construction evaluations to ensure proper water flow in drainage systems, optimal load-bearing capacity on roads, and flawless execution of irrigation lines. Arclight Developers takes pride in building infrastructure that communities can rely on for decades.</p>
                            
                            {/* You can change these images to show "Before and After" shots! */}
                            <div className="row mt-40 mb-40 portfolio__details-area-image">
                                <div className="col-sm-6 sm-mb-25">
                                    <img src={image1} alt="Project Phase 1" style={{ borderRadius: '10px' }} />
                                </div>
                                <div className="col-sm-6">
                                    <img src={image2} alt="Project Phase 2" style={{ borderRadius: '10px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PortfolioDetailsMain;